import { render } from "./Page_Detail.vue?vue&type=template&id=d85aa67c&scoped=true"
import script from "./Page_Detail.vue?vue&type=script&lang=js"
export * from "./Page_Detail.vue?vue&type=script&lang=js"

import "./Page_Detail.vue?vue&type=style&index=0&id=d85aa67c&scoped=true&lang=css"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85aa67c"]])

export default __exports__